// extracted by mini-css-extract-plugin
export default {"wrapper":"y3-z","play":"z3-z"};